import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppUtils {

  private subject: BehaviorSubject<any> = new BehaviorSubject({});
  private data: BehaviorSubject<any> = new BehaviorSubject({});

  constructor() { }

  // Set global data
  setData(sharedObject?: any) {
    this.subject.next(sharedObject);
  }

  // Get globally set data
  getData(): Observable<any> {
    return this.subject.asObservable();
  }

  setTxnData(sharedObject?: any) {
    this.data.next(sharedObject);
  }

  getTxnData(): Observable<any> {
    return this.data.asObservable();
  }

  /**
   * Method to get a particular json object from json array based on key and value.
   * @param array
   * @param key
   * @param value
   */
  getJsonObject(array, key, value) {
    if (array) {
      const data = array.filter(x => x[key] === value);
      return data ? data[0] : undefined;
    }
  }

  // Method to decode access token
  decodeJWT(jwtToken) {
    const base64Url = jwtToken.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return window.atob(base64);
  }

  logOut() {
    localStorage.clear();
    sessionStorage.clear();
  }

  //Retrieve the token from local storage.
  getAccessToken() {
    return localStorage.getItem('access_token');
  }

  // Retrieve the token from local storage.
  getDecodedToken() {
    return JSON.parse(localStorage.getItem('decoded_token'));
  }

  // Function to check the internal admin access of the user.
  isInternalAdmin() {
    const token = JSON.parse(localStorage.getItem('decoded_token'));
    if (token && token["omnitracs.com/system_permissions"] && token["omnitracs.com/system_permissions"]["sys:int:adm"]) {
      return true;
    }
    return false;
  }

  // Function to get the user info.
  getLoggedInUserId() {
    const token = JSON.parse(localStorage.getItem('decoded_token'));
    return token["sub"];
  }

  // Function to get the user info.
  getLoggedInUserEmailAddress() {
    const token = JSON.parse(localStorage.getItem('decoded_token'));
    return token["email"];
  }

  // Function to get the user info.
  getLoggedInUserCompanyId() {
    const token = JSON.parse(localStorage.getItem('decoded_token'));
    return token["co"];
  }

}